import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/routers/download/index.js'
Vue.use(VueRouter)
// const _base = process.env.NODE_ENV == 'development' ? '' : ''
export const router = new VueRouter({
  base: '/download',
  mode: 'history',
  routes
})

Vue.router = router

export default {
  router
}
